var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHardBounce = function SvgHardBounce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75H1.99444C1.55885 12.75 1.34105 12.75 1.17467 12.6652C1.02833 12.5907 0.909341 12.4717 0.834773 12.3253C0.75 12.159 0.75 11.9412 0.75 11.5056V0.75M14.75 1.86111L10.5233 6.0878C10.3693 6.24181 10.2923 6.31881 10.2035 6.34766C10.1254 6.37304 10.0413 6.37304 9.96316 6.34766C9.87437 6.31881 9.79736 6.24181 9.64336 6.0878L8.18998 4.63442C8.03597 4.48042 7.95897 4.40341 7.87017 4.37456C7.79207 4.34918 7.70793 4.34918 7.62983 4.37456C7.54103 4.40341 7.46403 4.48042 7.31002 4.63442L3.86111 8.08333M14.75 1.86111H11.6389M14.75 1.86111V4.97222",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHardBounce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hard-bounce.0a63268a.svg";
export { ForwardRef as ReactComponent };